import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../../axiosinterceptor";

const API =
  "/code_enhance_combined_review_workflow_episode_list";

export const REQUEST_STATUS = Object.freeze({
  IDLE: "IDLE",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
});

const initialPayload = {
  episode_identifier: [],
  is_global_search: false,
  medical_record_number: [],
  priority: [],
  pallas_priority: [],
  file_type: [],
  file_name: [],
  header_id: [],
  speciality: [],
  admission_date_from: "",
  admission_date_to: "",
  discharge_date_from: "",
  discharge_date_to: "",
  length_of_stay: [],
  lenght_of_stay_operator: "",
  health_fund: [],
  is_flagged:false,
  unassigned_page:false ,
  actual_drg: [],
  predicted_drg1: [],
  predicted_drg2: [],
  principal_diagnosis: [],
  procedure_code: [],
  flagged_status: [],
  status:[],
  audit_rule_ref_no: [],
  audit_short_description: [],
  coder_name: [],
  recall:false,
  version: "",
  page_number: 1,
  page_size: 10,
  sort_by: "",
  sort_order: "",
};

const initialState = {
  payload: initialPayload,

  combinedReviewData: {
    data: [],
    status: REQUEST_STATUS.IDLE,
    error: null,
  },
};

export const getCombinedReviewData = createAsyncThunk(
  "combinedReview/getCombinedReviewData",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { file_name, ...apiPayload } = payload;
      const response = await axiosInstance.post(API, apiPayload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const exportCombinedReviewCSV = createAsyncThunk(
  "combinedReview/exportCombinedReviewCSV",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/code_enhance_review_workflow_combined_export", payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong",
      );
    }
  },
);

const combinedReviewSlice = createSlice({
  name: "combinedReview",
  initialState,

  reducers: {
    setPayload(state, action) {
      state.payload = {
        ...state.payload,
        ...action.payload,
      };
    },
     setCombinedPayload(state, action) {
      state.payload = {
        ...state.payload,
        ...action.payload,
      };
    },

   resetCombinedPayload(state) {
  state.payload = { ...initialPayload };  
},

    resetCombinedReviewData(state) {
      state.combinedReviewData = {
        data: [],
        status: REQUEST_STATUS.IDLE,
        error: null,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getCombinedReviewData.pending, (state) => {
        state.combinedReviewData.status = REQUEST_STATUS.LOADING;
        state.combinedReviewData.error = null;
      })

      .addCase(getCombinedReviewData.fulfilled, (state, action) => {
        state.combinedReviewData.status = REQUEST_STATUS.SUCCESS;
        state.combinedReviewData.data = action.payload;
      })

      .addCase(getCombinedReviewData.rejected, (state, action) => {
        state.combinedReviewData.status = REQUEST_STATUS.FAILURE;
        state.combinedReviewData.error = action.payload;
      });
  },
});

export const {
  setPayload,
  resetCombinedPayload,
  setCombinedPayload,
 resetCombinedReviewData,
} = combinedReviewSlice.actions;
export const initialPayloadConst=initialPayload
export default combinedReviewSlice.reducer;